export default {
    last30Days: 'Последние 30 дней',
    last7Days:  'Последние 7 дней',
    lastMonth:  'Прошлый месяц',
    lastWeek:   'Последняя неделя',
    lastYear:   'Последний год',
    period:     'Период',
    thisMonth:  'Этот месяц',
    thisWeek:   'Эта неделя',
};
